import React, {useEffect, useState} from "react";
import { filterBy } from "@progress/kendo-data-query";
import {getNaicsCodes} from "../../../actions/AudienceDesignActions";
import {Label} from "@progress/kendo-react-labels";
import {MultiSelect} from "@progress/kendo-react-dropdowns";
import "./LegislativeDistricts.css";

const Naics = (props) => {
    // console.log(props)
    const [value, setValue] = useState([]);

    const [naicsOptions, setNaicsOptions] = useState([]);
    const [allData, setAllData] = useState([]);
    const [segmentGroup, setSegmentGroup] = useState("");
    const [segmentCategory, setSegmentCategory] = useState("");
    const [segmentId, setSegmentId] = useState("");
    const [partialVal, setPartialVal] = useState(0);
    // const [currentFilter, setCurrentFilter] = useState([]);

    useEffect(() => {
        const queryParam = {};
        if (segmentCategory !== "") queryParam.q = segmentCategory;
        getNaicsCodes(queryParam).then((res) => {
            if (res) {
                let data = [];
                res.data.forEach((obj) => {
                    data.push({
                        text: obj.title,
                        value: obj.naics,
                    });
                });
                if (data.length > 1) {
                    let newData = data.slice();
                    if(partialVal){
                        newData.unshift({text:partialVal.toString(), value:partialVal});
                    }
                    newData.unshift({text:"Select All", value:"Select All"});
                    data = newData;
                }
                // console.log(data)
                setNaicsOptions(data);
            }
        });
    }, [segmentCategory]);

    // const getNaicsCodes = (filter) => {
    //     const queryParam = {};
    //     if (segmentCategory !== "") queryParam.q = segmentCategory;
    //     getNaicsCodes(queryParam).then((res) => {
    //         if (res) {
    //             let data = [];
    //             res.data.forEach((obj) => {
    //                 data.push({
    //                     label: obj.title,
    //                     value: obj.naics,
    //                 });
    //             });
    //             setNaicsOptions(data);
    //         }
    //     });
    // };

    // This control is used in multiple places - one of which is Audience Design Edit
    // props.segmentEditInfo will be set when we come from the Edit segment page - here
    // we populate the control's value accordingly.
    useEffect(() => {
        console.log(props.segmentEditInfo);
        let arr = [];
        if (props.segmentEditInfo && Object.entries(props.segmentEditInfo).length > 0) {
            if (props.segmentEditInfo.data.segment_design.primaryData.naics) {
                props.segmentEditInfo.data.segment_design.primaryData.naics.forEach(optionValue => {
                    naicsOptions.find(option => {
                        if (option.value === optionValue) {
                            arr.push(option);
                        }
                        ;
                    })
                })
                setValue(arr);
            }
        }
    }, [props.segmentEditInfo]);


    const onNaicsFilterChange = (e) => {
        const filter = e.filter;
        if (filter.value.length < 3) return;
        if (filter.value.length === 3) {
            if(typeof Number(filter.value) === 'number'){
                setPartialVal(parseInt(filter.value));
            }
            setSegmentCategory(filter.value.toUpperCase());
        } else {
            setSegmentCategory(filter.value.toUpperCase());
        }
        const allData = naicsOptions.slice();
        const newData = filter.value.length >= 1 ? filterBy(allData, filter) : allData;
        setNaicsOptions(newData);
    };
    function getDifference(arr1, arr2) {
        return arr1.filter(obj1 =>
            !arr2.some(obj2 => JSON.stringify(obj1) === JSON.stringify(obj2))
        );
    }

    const onNaicsChange = (e) => {
        let values = [];
        // setCurrentFilter(e.target.value);
        // const currentItem = getDifference(e.target.value, value);
        if (e.value.some(e  => e.text === "Select All")) {
            // selectAll();
            let allValues = [];
            let existingValues = e.value.filter(item => item.text !== "Select All");
            naicsOptions.shift();
            //remove the 3 digit nacis value if in the "Select All"
            const filteredValues = naicsOptions.filter(obj => !/^\d{3}$/.test(obj.value))
            allValues = existingValues.concat(filteredValues);
            const allUniqueValues = allValues.filter((obj, index, self) =>
                    index === self.findIndex((t) => (
                        t["text"] === obj["text"]
                    ))
            )
            setValue(allUniqueValues);
            allUniqueValues.forEach((val) => {
                values.push(val.value);
            });
            props.formik.values.segment_design.primaryData.naics = values;
        }
        else if(e.value.some(e  => /^\d{3}$/.test(e.value))){
      //if
            const allUniqueValues = e.value.filter((obj, index, self) =>
                    index === self.findIndex((t) => (
                        t["text"] === obj["text"]
                    ))
            )
            setValue(allUniqueValues);
            allUniqueValues.forEach((val) => {
                values.push(val.value);
            });
            props.formik.values.segment_design.primaryData.naics = values;
        }
        else {
            setValue(e.value)
            e.value.forEach((val) => {
                values.push(val.value);
            });
            props.formik.values.segment_design.primaryData.naics = values;
            if (e.value.length === 0) setNaicsOptions([]);
        }
    };
    const selectAll = () => {
        let values = [];
        naicsOptions.shift();
        setValue(naicsOptions);
        naicsOptions.forEach((val) => {
            values.push(val.value);
        });
        props.formik.values.segment_design.primaryData.naics = values;
    };

    return (
        <div>
            <div className="form-group">
              <MultiSelect
                  className={"fields"}
                  data={naicsOptions}
                  autoClose={false}
                  placeholder="Select..."
                  textField="text"
                  dataItemKey="value"
                  filterable={true}
                  onFilterChange={onNaicsFilterChange}
                  onChange={onNaicsChange}
                  size="large"
                  value={value}
                  // style={{width: "32rem"}}
              />
              <Label className={"hint-standard"}>Search by industry name or NAICS Code.  Enter at least 3 characters.</Label>
            </div>
        </div>
    );
}

export default Naics;
